import { Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

const key = FilterKey.CONFIDENCE;
const list = [
  { label: 'Any Confidence', value: 'any' },
  { label: '90% and above', value: '>= 90' },
  { label: '80% and above', value: '>= 80' },
  { label: '70% and above', value: '>= 70' },
  { label: '60% and above', value: '>= 60' },
  { label: '50% and above', value: '>= 50' },
  { label: 'Under 50%', value: '<= 49' },
];
export const getConfidenceFilter = ({ activeFilters, userRole }: IGetFilterGroupsProps): Filter | null => {
  const canFilterConfidence = hasPerm(userRole || UserRole.Unknown, P.FILTER_CONFIDENCE);
  if (!canFilterConfidence) {
    return null;
  }

  const selectedValue = activeFilters?.[key]?.[0] ?? '';
  return {
    name: 'Confidence',
    key,
    showSearch: false,
    options: {
      SELECT_ONE: list.map(item => {
        return {
          value: item.value,
          label: item.label,
          checked: selectedValue === item.label,
        };
      }),
    },
  };
};
